import { Box, Button, ButtonAppearance, ButtonSize, Text } from '@bechtel/gds';
import { ForbiddenAccessStyled, ForbiddenTextContainer, IntialStyledLogo, NavLink } from './styled';
//@ts-ignore images ignore
import { HorseTraderInitialLogo } from '~/images';
import { ReactComponent as ForbiddenAccessIcon } from '~/images/forbidden-access.svg';

export const ForbiddenAccess = () => {
  return (
    <Box  flexDirection={{ sm: 'column' }}>
      <Box mt={{sm:'400'}} flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }}>
        <ForbiddenAccessStyled>
          <ForbiddenAccessIcon />
        </ForbiddenAccessStyled>
        <Box mt={{ sm: '600' }} mb={{ sm: '400' }}>
          <Text size="500" weight="600">
            You don’t have permission to access this site.
          </Text>
        </Box>
        <Box py={{ sm: '200' }}>
          <Text color="grey.600" size="400">
            Please check with the administrator
          </Text>
        </Box>
        <NavLink href={`mailto:htsupport@dl.bechtel.com`}>
          <Button size={ButtonSize.MEDIUM} appearance={ButtonAppearance.PRIMARY}>
            <Text size="400" weight="600">
              Contact Admin
            </Text>
          </Button>
        </NavLink>

        <ForbiddenTextContainer>
          <IntialStyledLogo>
          <HorseTraderInitialLogo height='100%' width="100%"/>
        </IntialStyledLogo>
          <Text family={'openSansSemiBold'} size="400" color="grey.400">
            {'ERROR 401 (Forbidden)'}
          </Text>
        </ForbiddenTextContainer>
      </Box>
    </Box>
  );
};
